import { UserClient } from '@contentsquare/uxanalytics-client';
import { ClientFactory } from './app.client.factory';
export class PermissionService {
    constructor(userId, userClient) {
        this.userId = userId;
        this.userClient = userClient;
        this.permissions = [];
        this.userClient = ClientFactory.get(UserClient);
    }
    async init(param) {
        var _a;
        if (param instanceof Array) {
            this.permissions = param;
            return;
        }
        const role = (await this.userClient.getUseRole(param).catch(_error => null));
        this.permissions = ((_a = role === null || role === void 0 ? void 0 : role.permissions) === null || _a === void 0 ? void 0 : _a.permissions) || [];
    }
    hasPermission(permissionParams) {
        const permission = this.getPermission(permissionParams);
        return this.permissions.includes(permission);
    }
    getPermission(permission) {
        if (typeof permission === 'string') {
            return permission;
        }
        else {
            const isOwner = permission.creatorId === this.userId;
            return (permission.permission + (isOwner ? 'Own' : 'All'));
        }
    }
}
//# sourceMappingURL=permission.service.js.map